import React, { useState } from "react";
import { Colxx } from "/@src/components/common/CustomBootstrap";
import { Card, CardBody } from "reactstrap";
import ReactImage from "/@src/components/newComponents/ReactImage";
import FileName from "/@src/components/newComponents/FileName";
import RenderMedia from "/@src/components/newComponents/RenderMedia";
import { openModal } from "/@src/redux/modal/actions";
import DeleteMedia from "./DeleteMedia";
import { useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";

function MediaThumb({
  media,
  selectedMedia,
  onMediaSelectChange,
  placeholderImage = "",
}) {
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);

  const deleteModal = () => {
    dispatch(
      openModal({
        id: "delete-media",
        title: "Confirm Delete Media",
        size: "md",
        children: <DeleteMedia media={media} />,
      })
    );
  };

  const openInNewTab = () => {
    window.open(media.mediaUrl, "_blank");
  };

  return (
    <Colxx
      sm="6"
      md="6"
      lg="4"
      xl="2"
      className="mb-3 mt-3 align-items-center justify-content-center"
    >
      <Card
        onClick={() => onMediaSelectChange(media)}
        // className={`${isSelected ? "selected" : ""} media-thumb`}
        className="media-thumb"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="position-relative media-img">
          {isHovered && (
            <div className="media-actions">
              <div>
                <span
                  onClick={deleteModal}
                  data-tooltip-id="action-delete"
                  data-tooltip-content="Delete"
                >
                  <i className="simple-icon-trash" />
                </span>

            <a href={media.mediaUrl} target="_blank" rel="noopener noreferrer">
                <span
                  data-tooltip-id="action-open-new-tab"
                  data-tooltip-content="Open in new tab"
                >
                  <i className="simple-icon-share-alt" />
                </span>
            </a>
                <Tooltip id="action-delete" />
                <Tooltip id="action-open-new-tab" />
              </div>
            </div>
          )}

          <RenderMedia
            media={media}
            url={media.mediaUrl}
            placeholder={placeholderImage}
            mediaStyles={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
            videoControls={false}
            videoAutoplay={false}
          />
        </div>
        <CardBody className="p-3">
          <FileName name={media.fileName} />
          <br />
          Size: <b>{media.fileSizeKb} KB</b>
        </CardBody>
      </Card>
    </Colxx>
  );
}

export default MediaThumb;
